export default __webpack_public_path__ + "static/media/imgSubCapaBranca2.753f5ad2.webp";